const BRIDGE_URL = 'http://localhost:8085';

class BridgeClient {
  async healthCheck() {
    try {
      const response = await fetch(`${BRIDGE_URL}/health`);
      return response.ok;
    } catch (error) {
      return false;
    }
  }

  async getPrinters() {
    try {
      const response = await fetch(`${BRIDGE_URL}/printers`);
      if (!response.ok) {
        throw new Error('Failed to fetch printers');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      throw new Error(`Bridge connection failed: ${error.message}`);
    }
  }

  async print(labelData, printer = null) {
    try {
      let payload;
      
      if (printer?.type === 'windows-printer') {
        payload = {
          data: labelData,
          printerName: printer.name,
          printerType: printer.type
        };
      } else {
        payload = {
          data: labelData,
          printerIP: printer?.ip || null,
          printerPort: printer?.port || '9100'
        };
      }

      const response = await fetch(`${BRIDGE_URL}/print`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Print job failed');
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Print failed: ${error.message}`);
    }
  }
}

export const bridgeClient = new BridgeClient();
